export default "/images/vendor/flag-icons/flags/4x3/ml.svg?fa530666ce9e170dc6cdcc03b6ef2f68";